import React from "react";
import { Link } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <SiteHeader />
      <main className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
        <div className="w-12 h-12 mx-auto grid place-items-center bg-amber-100 border border-amber-500 rounded-sm">
          <XCircle className="w-6 h-6 text-amber-700" />
        </div>
        <h1 className="font-heading text-3xl font-bold tracking-tight mt-6">Payment cancelled</h1>
        <p className="text-zinc-600 mt-3 text-sm max-w-md mx-auto">
          Your card was not charged. You can start over any time from your result page.
        </p>
        <Link to="/app" className="mt-6 inline-block font-mono text-xs underline underline-offset-4">
          Back to dashboard →
        </Link>
      </main>
    </div>
  );
}
